import { Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { getFilterItems } from '../../../../../helpers';
import { ConfigurationItemBadge } from '../../../../../components/ConfigurationItemBadge/ConfigurationItemBadge';
import { ConfigurationHoverCard } from '../../components/ConfigurationHoverCard/ConfigurationHoverCard';
import { CellContext, getFiltersSummary, getMeta, NO_VALUE } from '../../helpers';
import styles from './FiltersCell.module.css';

const CARD_TITLE = 'Filters';

export const FiltersCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading, countriesById, isLoadingCountries } = getMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    const summary = getFiltersSummary(original.filters);

    // A request that narrowed nothing has nothing for the card to add to the row.
    if (summary === NO_VALUE) {
        return <span>{summary}</span>;
    }

    const items = getFilterItems(original.filters, { countriesById, isLoadingCountries });
    // A place is shown as a badge of its own; every other filter reads as a label and its figure.
    const locationItems = items.filter((item) => !item.value);
    const boundItems = items.filter((item) => item.value);

    return (
        <ConfigurationHoverCard summary={summary} title={CARD_TITLE}>
            {locationItems.length > 0 && (
                <div className={styles.locations}>
                    {locationItems.map((item) => (
                        <ConfigurationItemBadge key={item.key} item={item} />
                    ))}
                </div>
            )}

            <dl className={styles.bounds}>
                {boundItems.map((item) => (
                    <div key={item.key} className={styles.bound}>
                        <dt className={styles.boundLabel}>{item.label}</dt>
                        <dd className={styles.boundValue}>{item.value}</dd>
                    </div>
                ))}
            </dl>
        </ConfigurationHoverCard>
    );
};
